module.exports = __webpack_public_path__ + "static/media/search-line.c4efe5c3.svg";